import { ValueObject } from '@sqior/js/data';
import { Entity } from '@sqior/js/entity';
import React from 'react';

export const SelectionPageContext = React.createContext<
  (menu: Entity, onClose: (ok: boolean, data?: ValueObject) => void) => void
>((menu, onClose) => {
  /* dummy */
});
